import { useEffect, useState, useRef } from 'react';

export const useCountAnimation = (targetCount, duration = 2000) => {
    const [count, setCount] = useState(0);
    const animationRef = useRef();

    useEffect(() => {
        if (!targetCount) return;

        const startCount = 0;
        const increment = targetCount / (duration / 16);
        let currentCount = startCount;

        const updateCount = () => {
            currentCount += increment;
            if (currentCount < targetCount) {
                setCount(Math.floor(currentCount));
                animationRef.current = requestAnimationFrame(updateCount);
            } else {
                setCount(targetCount);
            }
        };

        animationRef.current = requestAnimationFrame(updateCount);

        return () => {
            if (animationRef.current) {
                cancelAnimationFrame(animationRef.current);
            }
        };
    }, [targetCount, duration]);

    return count;
};
